import request from '../../axios';

export const getListLoanRule = async (loanRequestGuid: string) => {
  const {data}: {data: IListLoanRuleResponse} = await request.get(
    `/api/v2/payment/list-loan-rule/loan-request/${loanRequestGuid}`,
  );

  return data;
};
